import styled, { css } from "styled-components";
import { IThemeProps, themeTypes } from "../../../interfaces";
import { background, divider, inactiveItens, shadowColor } from "../../../theme";

export const Container = styled.div<IThemeProps>`
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 0.3125rem;
    outline: 0;
    min-width: 100vw;
    max-width: 100vw;
    min-height: calc(100 * var(--vh));
    max-height: calc(100 * var(--vh));
    box-shadow: 0.125rem 0.125rem 0.5rem ${props => shadowColor[props.theme as themeTypes]};
    @media (min-width: 550px) {
        min-width: 520px;
        max-width: 520px;
        min-height: auto;
        max-height: calc(90 * var(--vh));
    }
    ${props => css`
        background: ${background[props.theme as themeTypes]};
        color: ${inactiveItens[props.theme as themeTypes]};
    `}
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const ContainerForm = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    overflow: auto;
    max-height: calc(calc(90 * var(--vh)) - 170px);
`;

export const ContainerButtons = styled.div<IThemeProps>`
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    gap: 16px;
    border-top: 1px solid ${(props) => divider[props.theme as themeTypes]};
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    label {
        max-width: 100%;
    }
`;
